<template>
  <div>
    <h1 class="display-4">Dupliquer l'événement</h1>
    <hr />
    <h2 class="display-5">Vous souhaitez dupliquer cet événement...</h2>

    <div class="row">
      <div class="col-sm-6" v-show="list_establishments.length > 1">
        <h2 @click.prevent="more_establishments"><span class="badge badge-primary">pour un ou plusieurs autres établissements</span></h2>
      </div>
      <div class="col-sm-6">
        <h2 @click.prevent="more_dates"><span class="badge badge-primary">à une ou plusieurs dates</span></h2>
      </div>
    </div>
    <form class="mt-3" v-show="form_establishments">
      <div class="form-group">
        <label>Sélectionnez un ou plusieurs établissements</label>
        <select class="custom-select" multiple v-model="establishments_selected">
          <option v-for="item in list_establishments" :disabled="item.id == establishmentId" :value="item" :key="item.id">{{ item.school.name }} {{ item.city.name }} {{ item.id == establishmentId ? '(Etablissement original de cet événement)' : '' }}</option>
        </select>
        <div class="alert alert-danger mt-3" v-show="error_form">
          Vous devez au moins choisir un établissement
        </div>
      </div>
      <button type="submit" class="btn btn-primary submit" @click.prevent="duplicate">{{ button }}</button>
      <router-link to="/events">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </form>
    <form class="mt-3" v-show="form_dates">
      <div class="alert alert-info">
        En ajoutant des nouvelles dates, l'horaire des événements resteront identiques à l'événement initial
      </div>
      <div class="row form-group" v-for="input in inputs" :key="input.id">
        <div class="col-sm-6">
          <label :for="input.id">{{input.label}}</label>
          <datepicker :id="input.id" v-model="input.value" input-class="form-control" format="dd/MM/yyyy" placeholder="Date de début de l'événement" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlighted"></datepicker>
        </div>
        <div class="col-sm-6">
          <label :for="input.id">{{input.label2}}</label>
          <datepicker :id="input.id2" v-model="input.value2" input-class="form-control" format="dd/MM/yyyy" placeholder="Date de fin de l'événement" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlighted"></datepicker>
        </div>
      </div>
      <button class="btn btn-primary btn-sm float-right" @click.prevent="addInput">Ajouter une nouvelle date</button>
      <div class="clearfix"></div>
      <button type="submit" class="btn btn-primary submit2" @click.prevent="duplicateDate">{{ button }}</button>
      <router-link to="/events">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import * as Ladda from 'ladda'
import Datepicker from 'vuejs-datepicker'
import { fr } from 'vuejs-datepicker/dist/locale'
import Salesforce from '../../class/Salesforce'

Vue.use(VueResource)
Vue.component('datepicker', Datepicker)

export default {
  data () {
    return {
      counter: 0,
      inputs: [{
        id: 'datedebut0',
        id2: 'datefin0',
        label: 'Date de début',
        label2: 'Date de fin',
        value: '',
        value2: ''
      }],
      active: true,
      address: '',
      button: 'Dupliquer l\'événement',
      city: '',
      description: '',
      descriptionMarkdown: '',
      error_form: false,
      end_date: '',
      // end_date_registration: '',
      end_time: '',
      establishmentId: '',
      establishments_selected: [],
      eventbrite: '',
      facebook: '',
      form_establishments: false,
      form_dates: false,
      fr: fr,
      hightlighted: false,
      highlighted: {
        dates: [
          new Date()
        ]
      },
      is_live: false,
      list_establishments: [],
      google_map: '',
      imageId: '',
      labelId: '',
      label_name: '',
      linkId: '',
      link_name: '',
      postal_code: '',
      registration_required: '',
      // registration_page_expected: false,
      // registration_page_url: '',
      salesforce_campaign: '',
      schoolId: '',
      // specific_page_expected: false,
      // specific_page_url: '',
      start_date: '',
      // start_date_registration: '',
      start_time: '',
      title: '',
      total_events: 0,
      total_update: 0,
      typeId: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'divisionSF', 'establishments', 'recordTypeId', 'role', 'schoolSF', 'typeSF', 'userId']),
    id () {
      return this.$route.params.id
    },
    isIsg () {
      return this.schoolId === '63e11f451ea7572069151a14' || this.schoolId === '63e120881ea7572069151a50' || this.schoolId === '63e1218c1ea7572069151a7b' || this.schoolId === '63e1225e1ea7572069151aa5' || this.schoolId === '63e123211ea7572069151ad0' || this.schoolId === '63e0dee71ea75720691518ec' || this.schoolId === '63e1257d1ea7572069151aee' || this.schoolId === '63e125f21ea7572069151af1'
    },
    onSalesforce () {
      return this.schoolSF !== '' && this.typeSF !== ''
    }
  },
  methods: {
    ...Vuex.mapActions(['addDivisionSF', 'addRecordTypeId', 'addSchoolSF', 'addTypeSF']),
    addInput () {
      this.inputs.push({
        id: `datedebut${++this.counter}`,
        id2: `datefin${++this.counter}`,
        label: 'Date de début',
        label2: 'Date de fin',
        value: '',
        value2: ''
      })
    },
    addToSF (idEvent, establishment, status, dates) {
      // Quelques types sont ajoutés dans les campagnes SF
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            let school = data.school.name
            let division = data.school.name
            let city = this.isISG
              ? data.school.name.replace('ISG ', '')
              : data.city.name === 'Campus à distance'
                ? 'Distanciel'
                : data.city.name
            this.addSchoolSF(data.school.id)
            this.addDivisionSF(data.school.id)

            if (this.onSalesforce !== '' && school !== 'Epitech' && school !== 'Epitech Digital' && school !== 'SUPINFO') {
              this.button = 'Création de la campagne sur Salesforce'
              // On doit créer des nouvelles variables (à cause du this)
              let type = this.typeSF !== 'Autre' ? this.typeSF : 'EVENT GENERIQUE'
              let startDate = dates.start_date
              let titleDate = this.format_date_fr(dates.start_date)
              school = this.schoolSF
              division = this.divisionSF
              let description = this.description
              let startTime = this.start_time
              let endTime = this.end_time
              let endDate = ''
              let online = this.is_live
              if (dates.end_date !== '' && dates.end_date !== undefined) {
                endDate = dates.end_date
              } else {
                endDate = dates.start_date
              }
              let name = this.isISG ? type + ' - ' + data.city.name + ' - ' + city + ' - ' + titleDate : type + ' - ' + city + ' - ' + titleDate

              let sObject = {
                Name: name,
                School__c: school,
                Division__c: division,
                Campus__c: city,
                StartDate: startDate,
                EndDate: endDate,
                EventStartHour__c: startTime,
                Type: 'Event',
                Detail__c: type,
                Label__c: this.label_name,
                Description: description,
                EventDBID__c: idEvent,
                IsActive: this.active,
                IsOnline__c: online,
                RecordTypeId: this.recordTypeId
              }
              if (endTime !== '') {
                sObject.EventEndHour__c = endTime
              }

              let salesforce = new Salesforce()
              salesforce.login().then(
                (value) => {
                  console.log(value)
                  if (status === 'create') {
                    salesforce.create(sObject).then(
                      (value) => {
                        console.log('création campagne OK', value)
                        this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                          response.json().then((data) => {
                            this.total_update++
                          })
                        }, (response) => {

                        })
                      },
                      (value) => {

                      }
                    )
                  }
                },
                (value) => {
                  console.log(value)
                }
              )
            } else if (school === 'Epitech') {
              this.addToSFEpitech(idEvent, establishment, 'create')
            } else if (school === 'Epitech Digital' || school === 'SUPINFO') {
              this.addToSFEpitechDigital(idEvent, establishment, dates, 'create')
            } else {
              this.total_update++
            }
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    addToSFEpitechDigital (idEvent, establishment, dates, status) {
      // Quelques types sont ajoutés dans les campagnes SF
      console.log(this.typeSF)
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            // let school = data.school.name
            // let division = data.school.name
            let city = data.city.name === 'Campus à distance' ? 'Distanciel' : data.city.name

            this.button = 'Création de la campagne sur Salesforce'
            let startTimeFormated = ''
            if (this.start_time !== '') {
              let startTimeSplit = this.start_time.split('h')
              let hoursStart = parseInt(startTimeSplit[0]) + 1
              if (startTimeSplit[1] !== '') {
                startTimeFormated = hoursStart + ':' + startTimeSplit[1]
              } else {
                startTimeFormated = hoursStart
              }
            }
            let endTimeFormated = ''
            if (this.end_time !== '') {
              let endTimeSplit = this.end_time.split('h')
              let hoursEnd = parseInt(endTimeSplit[0]) + 1
              if (endTimeSplit[1] !== '') {
                endTimeFormated = hoursEnd + ':' + endTimeSplit[1]
              } else {
                endTimeFormated = hoursEnd
              }
            }
            // On doit créer des nouvelles variables (à cause du this)
            let type = this.typeSF
            let startDate = dates.start_date
            let titleDate = this.format_date_fr(dates.start_date)
            let description = this.description
            let online = this.is_live
            // let startTime = this.start_time
            let endTime = this.end_time
            let endDate = ''
            if (dates.end_date !== '' && dates.end_date !== undefined) {
              endDate = dates.end_date
            } else {
              endDate = dates.start_date
            }

            type = type === 'JDMI' ? 'Journée Immersive' : type

            let sObject = {
              Name: (type === 'Atelier' && this.divisionSF === 'Epitech Digital' ? 'Digiclub' : type) + ' - ' + city + ' - ' + titleDate,
              Ecole__c: this.divisionSF,
              Campus__c: city,
              StartDate: startDate,
              EndDate: endDate,
              Type: 'Event',
              Detail__c: type,
              Label__c: this.label_name,
              Description: description,
              Event_DB_ID__c: idEvent,
              IsActive: this.active,
              IsOnline__c: online
              // Webinar_URL__c: webinarUrl
            }
            if (startTimeFormated !== '') {
              sObject.EventStartHour__c = startTimeFormated
            }
            if (endTime !== '') {
              sObject.EventEndHour__c = endTimeFormated
            }

            let salesforce = new Salesforce()
            salesforce.login().then(
              (value) => {
                console.log(value)
                if (status === 'create') {
                  salesforce.createEda(sObject).then(
                    (value) => {
                      console.log('création campagne OK', value)
                      this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                        response.json().then((data) => {
                          this.total_update++
                        })
                      }, (response) => {

                      })
                    },
                    (value) => {

                    }
                  )
                }
              },
              (value) => {
                console.log(value)
              }
            )
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    addToSFEpitech (idEvent, establishment, status) {
      // Quelques types sont ajoutés dans les campagnes SF
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            let school = data.school.name
            let city = data.city.name

            if (school === 'Epitech' || school === 'Epitech Digital') {
              this.button = 'Création de la campagne sur Salesforce'
              // On doit créer des nouvelles variables (à cause du this)
              let nameSchool = school === 'Epitech' ? 'Epitech IT' : 'Epitech Digital'
              let type = this.typeSF
              let startDate = this.start_date
              let titleDate = this.format_date_fr(this.start_date)
              let endDate = this.end_date
              school = this.schoolSF
              let description = this.description
              let salesforceCampaign = this.salesforce_campaign
              let active = this.active

              let sObject = {
                Name: type + ' ' + nameSchool + ' - ' + city + ' - ' + titleDate,
                Campus__c: city,
                StartDate: startDate,
                Detail__c: type,
                Description: description,
                EventDBID__c: idEvent,
                IsActive: active
              }
              if (endDate !== '') {
                sObject.EndDate = endDate
              }
              let salesforce = new Salesforce()
              salesforce.loginEpitech().then(
                (value) => {
                  console.log(value)
                  if (status === 'create') {
                    salesforce.create(sObject).then(
                      (value) => {
                        console.log('création campagne OK', value)
                        this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                          response.json().then((data) => {
                            this.total_update++
                          })
                        }, (response) => {

                        })
                      },
                      (value) => {

                      }
                    )
                  }
                  if (status === 'update') {
                    sObject.Id = salesforceCampaign
                    salesforce.update(sObject).then(
                      (value) => {
                        this.total_update++
                      },
                      (value) => {

                      }
                    )
                  }
                },
                (value) => {
                  console.log(value)
                }
              )
            } else {
              this.total_update++
            }
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    duplicate () {
      this.total_events = this.establishments_selected.length
      this.error_form = false
      if (this.total_events > 0) {
        let l = Ladda.create(document.querySelector('.submit'))
        l.start()
        this.button = 'Duplication de l\'événement'
        for (let i = 0; i < this.total_events; i++) {
          let event = {
            active: this.active,
            address: this.establishments_selected[i].address,
            city: this.establishments_selected[i].ville,
            date_created: new Date().toISOString(),
            description: this.description,
            // descriptionMarkdown: this.descriptionMarkdown,
            end_time: this.end_time,
            establishmentId: this.establishments_selected[i].id,
            // eventbrite: this.eventbrite,
            // facebook: this.facebook,
            google_map: this.establishments_selected[i].map,
            hightlighted: false,
            imageId: this.imageId,
            ionisId: this.userId,
            labelId: this.labelId,
            linkId: this.linkId,
            link_name: this.link_name,
            postal_code: this.establishments_selected[i].zip_code,
            registration_required: this.registration_required,
            slider: false,
            start_date: new Date(this.start_date).toISOString().substring(0, 10),
            start_time: this.start_time,
            // title: this.title,
            typeId: this.typeId
          }

          if (this.end_date !== '' && this.end_date !== undefined) {
            event.end_date = new Date(this.end_date).toISOString()
          }
          if (this.start_date_registration !== '' && this.start_date_registration !== undefined) {
            event.start_date_registration = new Date(this.start_date_registration).toISOString()
          }
          if (this.end_date_registration !== '' && this.end_date_registration !== undefined) {
            event.end_date_registration = new Date(this.end_date_registration).toISOString()
          }
          event.establishmentId = this.establishments_selected[i].id
          this.$http.post(this.domain + '/api/events?access_token=' + this.access_token, event, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              if (response.status === 200 && response.ok) {
                let dates = {
                  end_date: event.end_date,
                  start_date: event.start_date
                }
                this.addToSF(data.id, this.establishments_selected[i].id, 'create', dates)
              }
            })
          }, (response) => {

          })
        }
      } else {
        this.error_form = true
      }
    },
    duplicateDate () {
      this.total_events = this.inputs.length
      this.error_form = false
      if (this.total_events > 0) {
        let l = Ladda.create(document.querySelector('.submit2'))
        l.start()
        this.button = 'Duplication de l\'événement'
        for (let i = 0; i < this.total_events; i++) {
          let event = {
            active: this.active,
            address: this.address,
            city: this.city,
            date_created: new Date().toISOString(),
            description: this.description,
            // descriptionMarkdown: this.descriptionMarkdown,
            end_time: this.end_time,
            establishmentId: this.establishmentId,
            // eventbrite: this.eventbrite,
            // facebook: this.facebook,
            google_map: this.google_map,
            hightlighted: false,
            imageId: this.imageId,
            ionisId: this.userId,
            labelId: this.labelId,
            linkId: this.linkId,
            link_name: this.link_name,
            postal_code: this.postal_code,
            registration_required: this.registration_required,
            slider: false,
            start_date: new Date(this.start_date).toISOString(),
            start_time: this.start_time,
            // title: this.title,
            typeId: this.typeId
          }

          if (this.inputs[i].value !== '') {
            event.start_date = new Date(this.inputs[i].value).toISOString().substring(0, 10)
          }
          if (this.inputs[i].value2 !== '') {
            event.end_date = new Date(this.inputs[i].value2).toISOString().substring(0, 10)
          }

          // if (this.end_date !== '' && this.end_date !== undefined) {
          //   event.end_date = new Date(this.end_date).toISOString()
          // }
          // if (this.start_date_registration !== '' && this.start_date_registration !== undefined) {
          //   event.start_date_registration = new Date(this.start_date_registration).toISOString()
          // }
          // if (this.end_date_registration !== '' && this.end_date_registration !== undefined) {
          //   event.end_date_registration = new Date(this.end_date_registration).toISOString()
          // }
          // event.establishmentId = this.establishments_selected[i]
          this.$http.post(this.domain + '/api/events?access_token=' + this.access_token, event, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              if (response.status === 200 && response.ok) {
                let dates = {
                  end_date: event.end_date,
                  start_date: event.start_date
                }
                this.addToSF(data.id, this.establishmentId, 'create', dates)
              }
            })
          }, (response) => {

          })
        }
      } else {
        this.error_form = true
      }
    },
    format_date (value) {
      let date = new Date(value)
      if (value) {
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return value
    },
    format_date_fr (value) {
      let date = new Date(value)
      if (value) {
        return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
      }
      return value
    },
    more_establishments () {
      this.form_dates = false
      this.form_establishments = true
    },
    more_dates () {
      this.form_establishments = false
      this.form_dates = true
    }
  },
  watch: {
    // total_update (number) {
    //   if (number === this.total_events) {
    //     this.$router.push({name: 'Events', query: {event: 'duplicate'}})
    //   }
    // }
    total_update (number) {
      console.log(number, this.total_events)
      if (number === this.total_events) {
        this.$root.$bvToast.toast('L\'événement a bien été dupliqué', {
          title: 'Evénement dupliqué',
          autoHideDelay: 3000,
          append: false,
          variant: 'success'
        })
        this.$router.push({name: 'Events'})
      }
    }
  },
  mounted () {
    this.$http.get(this.domain + '/api/events/' + this.id + '?filter[include][0][establishment]=school&filter[include][1]=label&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        this.active = data.active
        this.address = data.address
        this.city = data.city
        this.description = data.description
        // this.descriptionMarkdown = data.descriptionMarkdown
        this.end_date = this.format_date(data.end_date)
        // this.end_date_registration = this.format_date(data.end_date_registration)
        this.end_time = data.end_time
        this.establishmentId = data.establishmentId
        // this.eventbrite = data.eventbrite
        // this.facebook = data.facebook
        this.google_map = data.google_map
        // this.hightlighted = data.hightlighted
        this.imageId = data.imageId
        this.is_live = data.is_live
        this.labelId = data.labelId
        this.label_name = data.label.name
        this.linkId = data.linkId
        this.link_name = data.link_name
        // this.map = data.map
        this.postal_code = data.postal_code
        // this.registration_page_url = data.registration_page_url
        // this.specific_page_url = data.specific_page_url
        this.registration_required = data.registration_required
        this.schoolId = data.establishment.school.id
        this.start_date = this.format_date(data.start_date)
        // this.start_date_registration = this.format_date(data.start_date_registration)
        this.start_time = data.start_time
        this.title = data.title
        this.typeId = data.typeId
        // if (this.registration_page_url !== '') {
        //   this.registration_page_expected = true
        // }
        // if (this.specific_page_url !== '') {
        //   this.specific_page_expected = true
        // }
        this.addSchoolSF(data.establishment.schoolId)
        this.addDivisionSF(data.establishment.schoolId)
        this.addTypeSF(data.typeId)
        if (data.establishment.schoolId === '5b9bcb4690c8a831489aefd1') {
          this.addSchoolSF('ESME')
          this.addRecordTypeId('0121p000000BHqT')
          if ((this.typeId !== '5bd0237d08695f9cd07a0092' && this.typeId !== '5dd3ac53a413380bd3698710' && this.typeId !== '5ba8a2381b1a92ca1db3f662' && this.typeId !== '5b9fcacdc2e4315bd836890d' && this.typeId !== '6012b7b503ec68c4e6899166') && this.schoolId === '5b9bcb4690c8a831489aefd1') {
            this.addTypeSF('')
          }
        }
        this.$http.get(this.domain + '/api/establishments?filter[include]=school&filter[include]=city&access_token=' + this.access_token).then((response) => {
          response.json().then((data) => {
            // this.list_establishments = data
            for (let i = 0; i < data.length; i++) {
              if (data[i].school.id === this.schoolId) {
                this.list_establishments.push(data[i])
              }
            }
          })
        }, (response) => {

        })
      })
    }, (response) => {

    })
    // let where = ''
    // trouver une solution
    // if (this.role !== 'admin') {
    //   for (let i = 0; i < this.establishments.length; i++) {
    //     where += '&filter[where][or][' + i + '][id]=' + this.establishments[i]
    //   }
    // }
  }
}
</script>

<style lang="scss">
  h2 { cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/Events/Duplicate.vue